import React, { useState } from 'react';
import cn from 'classnames';

interface Option {
  id: string;
  label: string;
}

interface SegmentedControlProps {
  title?: string;
  options: Option[];
  selectedOption?: string;
  onChange: (optionId: string) => void;
  className?: string;
}

export const SegmentedControl: React.FC<SegmentedControlProps> = ({
  title,
  options,
  selectedOption,
  onChange,
  className = '',
}) => {
  const [selected, setSelected] = useState(
    selectedOption || options[0]?.id || '',
  );

  const handleOptionClick = (optionId: string) => {
    setSelected(optionId);
    onChange(optionId);
  };

  if (!options || options.length === 0) {
    return null;
  }

  return (
    <div className={cn('flex flex-col gap-2', className)}>
      {title && (
        <div className="text-sm font-medium text-gray-700 mb-1">{title}</div>
      )}
      <div className="flex bg-white border border-gray-200 rounded-lg p-0.5 shadow-sm">
        {options.map((option, index) => {
          const isSelected = option.id === selected;
          const isFirst = index === 0;
          const isLast = index === options.length - 1;
          
          return (
            <button
              key={option.id}
              className={cn(
                'flex-1 flex items-center justify-center gap-1.5 px-3 py-2 border-none bg-transparent text-gray-600 text-sm font-medium cursor-pointer transition-all duration-150 min-h-[36px]',
                {
                  'bg-blue-600 shadow-sm': isSelected,
                  'hover:bg-gray-50 hover:text-gray-900': !isSelected,
                  'rounded-l-md': isFirst,
                  'rounded-r-md': isLast,
                },
              )}
              onClick={() => handleOptionClick(option.id)}
              type="button"
            >
              {isSelected && (
                <span className="text-xs font-bold">✓</span>
              )}
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};
